import { Injectable } from '@angular/core';
import { Response, Headers } from '@angular/http';
import { Observable, Subject, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationService } from './configuration.service';
import { StorageService } from './storage.service';
import { IUser } from '../models/user.model';
import { IResult } from '../models/result.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class SecurityService {
  private user = {} as IUser;
  private actionUrl: string;
  private storage: StorageService;
  private authenticationSource = new Subject<boolean>();
  private authenticationSourceExternal = new Subject<boolean>();
  authenticationChallenge$ = this.authenticationSource.asObservable();
  authenticationChallengeExternal$ = this.authenticationSourceExternal.asObservable();
  private authorityUrl = '';

  constructor(private _http: HttpClient
    , private _router: Router
    , private route: ActivatedRoute
    , private _configurationService: ConfigurationService
    , private _storageService: StorageService
    , private spinner: NgxSpinnerService) {
    this.storage = _storageService;

    this._configurationService.settingsLoaded$.subscribe(x => {
      this.authorityUrl = this._configurationService.serverSettings.identityUrl
      this.storage.store('identityUrl', this.authorityUrl);
    });

    if (this.storage.retrieve('isAuthorized') !== '') {
      this.IsAuthorized = this.storage.retrieve('isAuthorized');
      this.authenticationSource.next(true);
      this.UserData = this.storage.retrieve('userData');
    }
  }

  public IsAuthorized: boolean;

  public GetToken(): any {
    return this.storage.retrieve('authorizationData');
  }

  public ResetAuthorizationData() {
    this.storage.store('authorizationData', '');
    this.IsAuthorized = false;
    this.storage.store('isAuthorized', false);
    this.storage.store('roles', '');
    this.storage.store('userData', '');
    this.storage.store('identityUrl', '');
    this.storage.store('openingUrl', '');
    this.storage.store('recruitmentUrl', '');
    this.storage.store('requestUrl', '');
    this.storage.store('quoteUrl', '');
    this.storage.store('payrollUrl', '');
    this.storage.store('messageUrl', '');
    this.storage.store('incidentUrl', '');
    this.storage.store('requisition', '');
    this.storage.store('moneyUrl', '');
  }

  public UserData: any;
  public SetAuthorizationData(token: any, id_token: any) {
    if (this.storage.retrieve('authorizationData') !== '') {
      this.storage.store('authorizationData', '');
    }

    this.storage.store('authorizationData', token);
    this.storage.store('authorizationDataIdToken', id_token);
    this.IsAuthorized = true;
    this.storage.store('isAuthorized', true);
  }
  public getProfileStorage(view): string {
    const showRoles = this.storage.retrieve('roles');
    if (showRoles !== '') {
      const rol = showRoles.listRoles.filter((item) => item.nameModule.toLowerCase() == view.toLowerCase());
      if (rol.length < 0) {
        return '';
      } else {
        return rol[0].nameRole;
      }
    }
  }
  public getUserDataStorage(): IUser {
    const userData = this.storage.retrieve('userData');
    if (userData !== '') {
      return userData;
    }
  }
  public getUserRolesStorage(): any {
    return this.storage.retrieve('roles');
  }

  public Logoff() {
    let post_logout_redirect_uri = location.origin;
    this.ResetAuthorizationData();
    window.location.href = post_logout_redirect_uri;
  }

  public GetRolesUser(currentRoute: string, param?: string) {
    this.getRoles()
      .subscribe((res) => {
        if (res.data === null) {
          this.authenticationSource.next(false);
          this._router.navigate(['/Unauthorized']);
        } else {
          let data: any = res.data;
          this.storage.store('isAuthorized', true);
          this.storage.store('roles', data);

          this.user.userId = data.userId;
          this.storage.store('userData', this.user);

          switch (currentRoute) {
            case 'budget-approval':
              this._router.navigate(['/budgets/budget-approval',
                { id: param, action: 'update' }], { relativeTo: this.route });
              break;
            case 'external-customer-commission':
              this._router.navigate(['/payroll/external-customer-commission',
                { id: param, routeType: 'external' }], { relativeTo: this.route });
              break;
            case 'external-customer-payroll':
              this._router.navigate(['/payroll/external-customer-payroll',
                { id: param, routeType: 'external', module: 'payroll' }], { relativeTo: this.route });
              break;
            case 'external-recruitment':
              this._router.navigate(['/recruitments/external-recruitment',
                { id: param, action: 'update', routeType: 'external' }], { relativeTo: this.route });
              break;
            case 'external-request-capture':
              this._router.navigate(['/recruitments/external-request-capture']);
              break;
            default:
              this._router.navigate([currentRoute]);
              break;
          }
        }
      },
        (error) => this.HandleError(error));
  }

  private getRoles(): Observable<IResult> {
    const url = this.storage.retrieve('identityUrl') + 'api/roles/getRolesEmployee/';

    let options = {};
    options["headers"] = new HttpHeaders()
      .append('authorization', 'Bearer ' + this.GetToken());

    return this._http.post(url, this.user, options)
      .pipe(
        map((res: Response) => {
          return res as any;
        })
      );
  }

  public MapNewUsuario(): IUser {
    const usuario = {} as IUser;
    usuario.username = '';
    usuario.password = '';

    return usuario;
  }

  public GetAuthorizationUser(usuario: IUser) {
    this.getToken(usuario)
      .subscribe((data) => {
        this.storage.store('authorizationData', data);
        this.authenticationSource.next(true);
      },
        (error) => this.HandleError(error));
  }
  public GetAuthorizationExternalUser(usuario: IUser) {
    this.getToken(usuario)
      .subscribe((data) => {
        this.storage.store('authorizationData', data);
        this.authenticationSourceExternal.next(true);
      },
        (error) => this.HandleError(error));
  }
  private getToken = (usuario: IUser): Observable<string> => {
    this.user = usuario;
    let options = {};
    if (this.authorityUrl === '') {
      this.authorityUrl = this.storage.retrieve('identityUrl');
    }

    const url = this.authorityUrl + 'api/tokens/auth';
    return this._http.post(url, usuario, options)
      .pipe(
        map((res: Response) => {
          return res as any;
        })
      );
  }

  public HandleError(error: any) {
    this.spinner.hide();
    if (error instanceof ErrorEvent) {
      console.error('Client side network error occurred:', error.error.message);
    } else {
      console.error('Backend - ' +
        `status: ${error.status}, ` +
        `statusText: ${error.statusText}, ` +
        `url: ${error.url}`);
      if (error.status == 403) {
        this._router.navigate(['/Forbidden']);
      } else if (error.status == 401) {
        this.authenticationSource.next(false);
        this._router.navigate(['/Unauthorized']);
      }
    }
    return throwError(error || 'server error');
  }
}
